import { render, staticRenderFns } from "./MaterialManagement.vue?vue&type=template&id=971de280"
import script from "./MaterialManagement.vue?vue&type=script&lang=js"
export * from "./MaterialManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports